import { ROUTES_STATIC } from '../constants'

let CAMERAS = []
let ROUTES = { ...ROUTES_STATIC }
let TITLE = ''
let REFRESH_MIN = 5
let ORDER_ID = 0
let DEFAULT_LANG = 'de'
let PROJECT_FILE_DATE = ''
let PROJECT_FINISHED = false

let _initialized = false
const isPortalConfigInitialized = () => _initialized

// called once by portalConfigLoader after the GraphQL fetch (see src/index.js); `protection`/`disabled` are per-route bool maps merged into ROUTES_STATIC; defaultLang from order.projectLanguage
function initPortalConfig({ cameras, title, refreshMin, orderId, defaultLang, projectFileDate, projectFinished, protection, disabled }) {
    CAMERAS = Object.freeze(cameras)
    TITLE = title
    REFRESH_MIN = refreshMin
    ORDER_ID = orderId
    DEFAULT_LANG = defaultLang || 'de'
    PROJECT_FILE_DATE = projectFileDate || ''
    PROJECT_FINISHED = !!projectFinished
    ROUTES = Object.freeze(
        Object.fromEntries(
            Object.entries(ROUTES_STATIC).map(([key, staticPart]) => [
                key,
                Object.freeze({ ...staticPart, protected: !!protection?.[key], disabled: !!disabled?.[key] })
            ])
        )
    )

    _initialized = true
}

export { CAMERAS, ROUTES, TITLE, REFRESH_MIN, ORDER_ID, DEFAULT_LANG, PROJECT_FILE_DATE, PROJECT_FINISHED, isPortalConfigInitialized, initPortalConfig }